import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { useDraftCqrsFind } from '@dreryk/react-draft';

import { getReferralDraftToken } from '../referral.draft';
import { referralTranslationKeys } from '../translations';

import { ReferralToPsychiatricHospitalFormBean } from './ReferralToPsychiatricHospitalForm/referralToPsychiatricHospitalForm.types';
import { referralToPsychiatricHospitalDraftSchema } from './referralToPsychiatricHospital.draft';

type ReferralToPsychiatricHospitalPanelLoaderChildrenProps = {
   referralToPsychiatricHospitalDraft: ReferralToPsychiatricHospitalFormBean | null;
};

type ReferralToPsychiatricHospitalPanelLoaderProps = {
   readonly children: ({
      referralToPsychiatricHospitalDraft,
   }: ReferralToPsychiatricHospitalPanelLoaderChildrenProps) => JSX.Element;
   readonly visitId: number;
};

export const ReferralToPsychiatricHospitalPanelLoader = (
   props: ReferralToPsychiatricHospitalPanelLoaderProps
): JSX.Element => {
   const {
      data: referralToPsychiatricHospitalDraft,
      loading: referralToPsychiatricHospitalDraftLoading,
      error: referralToPsychiatricHospitalDraftError,
   } = useDraftCqrsFind(
      { token: getReferralDraftToken('referralToPsychiatricHospital', props.visitId) },
      referralToPsychiatricHospitalDraftSchema
   );

   if (referralToPsychiatricHospitalDraftLoading) {
      return <LoaderSpinner />;
   }

   if (referralToPsychiatricHospitalDraftError) {
      return (
         <Message
            testId={'referralToPsychiatricHospitalFetchError'}
            type={MessageType.NEGATIVE}
            label={referralTranslationKeys.referralFetchError}
            displayIndicator
         />
      );
   }

   return props.children({
      referralToPsychiatricHospitalDraft: referralToPsychiatricHospitalDraft?.contents ?? null,
   });
};
